import { techDocs } from "../technical-docs";

export default techDocs('acoustics', 'Acústica', 'documentos-tecnicos-acustica')